import { api } from "./api/client";
import type {
  CATracking,
  CompraAgil,
  CompraAgilListResponse,
  FamiliaUnspsc,
  ListCompraAgilParams,
} from "@/types";

function toParams(params: ListCompraAgilParams = {}): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = String(v);
  }
  return out;
}

export const compraAgilService = {
  list: async (params: ListCompraAgilParams = {}): Promise<CompraAgilListResponse> =>
    (await api.get<CompraAgilListResponse>("/compra-agil", { params: toParams(params) })).data,

  familias: async (): Promise<FamiliaUnspsc[]> =>
    (await api.get<FamiliaUnspsc[]>("/compra-agil/familias")).data,

  detalle: async (id: string): Promise<CompraAgil> =>
    (await api.get<CompraAgil>(`/compra-agil/${encodeURIComponent(id)}`)).data,

  track: async (id: string): Promise<CATracking> =>
    (await api.post<CATracking>(`/compra-agil/${encodeURIComponent(id)}/track`)).data,

  updateTracking: async (
    id: string,
    dto: { estadoPipeline?: string; prioridad?: string; responsable?: string; notas?: string },
  ): Promise<CATracking> =>
    (await api.patch<CATracking>(`/compra-agil/${encodeURIComponent(id)}/tracking`, dto)).data,
};
